import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FilterContainerComponent } from '../filter-container/filter-container.component';
import { SelectionModel } from '@angular/cdk/collections';

export interface SimpleRadioSelectionOption
{
    label: string;
    value: any;
}

@Component({
    selector: 'report-filter-simple-radio-selector',
    templateUrl: './simple-radio-selector.component.html',
    styleUrls: ['./simple-radio-selector.component.scss'],
})
export class SimpleRadioSelectorComponent implements OnInit, AfterViewInit
{

    @Input() public label: string = 'Label Not Set';

    @Input() public container: FilterContainerComponent;

    @Input() public options: SimpleRadioSelectionOption[] = [];

    public selection: SelectionModel<any> = new SelectionModel<any>();

    constructor() {
    }

    ngOnInit() {
        this.container.register(this);
        this.selection.select(this.options[0].value);
    }

    ngAfterViewInit(): void {
        this.container.notifyReady(this);
    }
}
